import { api } from '../axiosClient';
import { ConfigurationSettingsResponse } from './configurationSettings.types';

const CONFIGURATION_SETTINGS_PATH = '/Configuration/settings';

export const getConfigurationSettings =
  (): Promise<ConfigurationSettingsResponse> => {
    return api.get(CONFIGURATION_SETTINGS_PATH);
  };
